import { render } from "./scrollableMenu.vue?vue&type=template&id=79284758"
import script from "./scrollableMenu.vue?vue&type=script&lang=js"
export * from "./scrollableMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__